import { Scale } from 'lucide-react';
import { type ComponentType, lazy } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';

/**
 * Юридичний контур (М9): замовлення «Відпрацювання» (картка, шлюз старту, стадії, строки, якість Q1–Q3,
 * зміни, скарги, завершення), ОЕ з таймером 8 робочих годин, клієнти й конфлікт інтересів, довідник послуг
 * («Структура ЮВ»), календар строків, панель РОО. У задачі, створеній замовленням, — рядок «Замовлення».
 */
const LegalTaskFields = lazy(() => import('./TaskLegal'));

const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const legalModule: ModuleDefinition = {
  key: 'legal',
  label: 'Юридичний контур',
  icon: Scale,
  basePath: '/legal',
  scope: 'legal:read',
  order: 30,
  routes: [
    {
      ...page(() => import('./LegalLayout')),
      children: [
        { index: true, lazy: async () => ({ Component: (await import('./LegalLayout')).LegalIndex }) },
        { path: 'matters', ...page(() => import('./pages/MattersPage')) },
        { path: 'matters/:matterId', ...page(() => import('./pages/MatterPage')) },
        { path: 'deadlines', ...page(() => import('./pages/DeadlinesPage')) },
        { path: 'oe', ...page(() => import('./pages/OePage')) },
        { path: 'oe/:oeId', ...page(() => import('./pages/OeDetailPage')) },
        { path: 'oe-reports', ...page(() => import('./pages/OeReportsPage')) },
        { path: 'clients', ...page(() => import('./pages/ClientsPage')) },
        { path: 'clients/:clientId', ...page(() => import('./pages/ClientPage')) },
        { path: 'services', ...page(() => import('./pages/ServicesPage')) },
        { path: 'services/:serviceId', ...page(() => import('./pages/ServicePage')) },
        { path: 'complaints', ...page(() => import('./pages/ComplaintsPage')) },
        { path: 'complaints/:complaintId', ...page(() => import('./pages/ComplaintPage')) },
        { path: 'approvals', ...page(() => import('./pages/ApprovalsPage')) },
        { path: 'dashboard', ...page(() => import('./pages/DashboardPage')) },
        { path: 'settings', ...page(() => import('./pages/SettingsPage')) },
      ],
    },
  ],
  task: { Fields: LegalTaskFields },
};

export default legalModule;
